import { Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { cloneDeep, isEqual } from "lodash";
import { useCallback } from "react";
import {
  ContractTaskDateReminderDto,
  DefaultNotificationSettingsDto,
} from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../../common/errors/useApiError";
import { useSaveOrganization } from "../../organizations/current/useOrganizationEditor";
import { DeleteSettingButton } from "./DeleteSettingButton";
import { initSettings } from "./NotificationSettings";
import { useReceiverRoleNames } from "./useReceiverRoleNames";

export const ContractTaskDueDateReminderSetting = ({
  setting,
}: {
  setting: ContractTaskDateReminderDto;
}) => {
  const roleName = useReceiverRoleNames();
  const authState = useLoggedInWithOrgContextState();
  const { trigger } = useApiError();

  const { saveOrganization, isSaving } = useSaveOrganization();

  const leadTimeUnits = {
    Days: t("days"),
    Months: t("months"),
  };

  const deleteSetting = useCallback(async () => {
    const settings: DefaultNotificationSettingsDto =
      cloneDeep(authState.selectedOrg.defaultNotificationSettings) ??
      initSettings();
    settings.contractTaskNotificationSettings.dueDateNotifications =
      settings.contractTaskNotificationSettings.dueDateNotifications.filter(
        (s) => !isEqual(s, setting),
      );
    try {
      await saveOrganization({ defaultNotificationSettings: settings });
    } catch (e) {
      trigger(e);
    }
  }, [
    authState.selectedOrg.defaultNotificationSettings,
    trigger,
    setting,
    saveOrganization,
  ]);

  return (
    <Flex
      flexDirection={"column"}
      fontSize={"sm"}
      backgroundColor={"gray.50"}
      rounded="md"
      p="2"
      my="1"
    >
      <Flex justifyContent={"space-between"} width="full">
        <Text>{t("Time of notification")}</Text>
        <DeleteSettingButton isLoading={isSaving} onClick={() => deleteSetting()} />
      </Flex>
      <Text fontWeight={"bold"}>
        {setting.leadTime.amount} {leadTimeUnits[setting.leadTime.unit]}{" "}
        {t("before date")}
      </Text>
      <Text>{t("Receiver")}</Text>
      {setting.receivers.contractTaskRoles.map((role) => (
        <Text key={role} fontWeight={"bold"}>
          {roleName.contractTaskRole(role)}
        </Text>
      ))}
    </Flex>
  );
};
